import type { FormLayout } from './types';

export const DEFAULT_FORM_LAYOUT: FormLayout = 'vertical';
